<template lang="pug">
	PopupBody.insertion--detail-tool-actions(@content-changed="onContentChanged")
		.flex-col
			slot
		template(slot="actions-right")
			DxButton(:text="$tCaption('OK', '@actions')", type="default", @click="src.applyEditTag")
			DxButton(:text="$tCaption('Cancel', '@actions')", @click="src.editingTag = null")
		.flex-row.space.align-center(v-if="!src.ssmlOnly && !playActionsHidden", slot="actions-left")
			DxButton(v-if="src.isPlaying != 1", :text="$tCaption('Play text')", type="default", icon="fas fa-play", @click="play('text')")
			DxLoadIndicator(v-if="src.isPlaying > 0", :height="20", :width="20")
			DxButton(v-if="src.isPlaying != 2", :text="$tCaption('Play mix')", type="default", icon="fas fa-play", @click="play('mix')")
			DxButton(v-if="src.isPlaying", :text="$tCaption('Stop', '@actions')", type="normal", icon="fas fa-stop", @click="stop")
			slot(name="actions-left")
</template>

<script>
	import DxButton from 'devextreme-vue/button';
	import PopupBody from 'app-core/PopupBody.vue';
	import { DxLoadIndicator } from 'devextreme-vue/load-indicator';

	export default {
		translationCategory: 'insertion.DetailToolActions',
		name: 'insertion--detail-tool-actions',
		components: { DxButton, PopupBody, DxLoadIndicator },		
		props: ['src', 'playActionsHidden'],
		data() {
			return {

			}
		},		
		watch: {
		
		},
		mounted() {
			if (__DEBUG__) {
				window.insertionDetailsToolActions = this;
				console.debug('ActionsToolsLoaded');
			}
		},
		destroyed() {
			this.stop();
		},
		methods: {
			onContentChanged(v) {
				let cmp = null;
				let curCmp = this;
				while(curCmp && !cmp) {
					if (curCmp?.processAutoSize) {
						cmp = curCmp;
					} else {
						curCmp = curCmp?.$parent;
					}
				}

				if (cmp) {
					cmp.processAutoSize(v);
				}
			},
			play(mode) {
				this.src.startPlayCreative(mode === 'text');
				//() => { applyJoditReadingRules(true).then(() => startPlayCreative()); }
			},
			stop() {
				this.src.stopPlayCreative();
			}
		}
	};
</script>
<style lang='scss'>
	.insertion--detail-tool-actions {

	}
</style>
